<template>
  <div class="ep-radio">
    <slot></slot>
  </div>
</template>

<script>
  import unit from '../../../lib/unit'
  export default {
    name: 'ep-radio',
    props: {
      value: {
        default: ''
      }
    },
    created() {
      this.$on('change', (val) => {
        this.broadcast('ep-radio-list', 'change', val)
      })
    },
    mixins: [unit],
  }
</script>

<style scoped>
  .ep-radio {
    height: 100%;
    width: auto;
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// radio.vue?6a7e643f